import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { MistakesChecklist } from "../components/MistakesChecklist";

export default function ChecklistPage() {
  return (
    <div className="pt-10">
      <Seo {...SEO.checklist} />
      <MistakesChecklist />
    </div>
  );
}
